import React from 'react';
import styles from './AboutUsSection.module.css';

const ecosystemItems = [
  'Client information',
  'Biomarker insights',
  'Dietary analysis',
  'Evidence-based workflows'
];

const AboutUsSection: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.canvas}>
        <header className={styles.intro}>
          <p className={styles.eyebrow}>About Us</p>
          <h2 className={styles.heading}>
            Transforming nutrition science into scalable personalized care.
          </h2>
          <p className={styles.tagline}>
            Personalized nutrition is powerful — but delivering it at scale is complex.
          </p>
        </header>

        <div className={styles.contentGrid}>
          <div className={styles.storyColumn}>
            <article className={styles.storyBlock}>
              <p className={styles.blockLabel}>The challenge</p>
              <p className={styles.bodyText}>
                Nutrition practitioners today manage client histories, dietary patterns, biomarkers,
                meal planning, follow-ups, and progress tracking across multiple disconnected tools —
                creating administrative burden and limiting the time available for meaningful client care.
              </p>
            </article>

            <article className={styles.storyBlock}>
              <p className={styles.blockLabel}>Built for practitioners</p>
              <p className={styles.bodyText}>
                CalorieScience was built by nutrition professionals, for nutrition professionals.
              </p>
              <p className={styles.bodyText}>
                CalorieScience helps practitioners transform complex client data, biomarkers, and
                nutrition science into personalized care — reducing admin, improving efficiency,
                and enabling practice growth.
              </p>
            </article>
          </div>

          <aside className={styles.platformPanel}>
            <p className={styles.panelLabel}>AI-assisted nutrition intelligence platform</p>
            <h3 className={styles.panelTitle}>One connected ecosystem</h3>
            <p className={styles.panelText}>
              Our UK/EU GDPR-compliant platform brings together client information, biomarker
              insights, dietary analysis, and evidence-based nutrition workflows.
            </p>
            <ul className={styles.ecosystemList}>
              {ecosystemItems.map(item => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </aside>
        </div>

        <div className={styles.intelligenceBand}>
          <div className={styles.bandCopy}>
            <p className={styles.blockLabel}>Beyond calorie tracking</p>
            <p className={styles.bodyText}>
              Unlike traditional nutrition software, CalorieScience goes beyond calorie tracking
              and meal planning. Our intelligence engine maps relationships between biomarkers,
              nutrients, foods, and drug–nutrient interactions to support more informed,
              personalized nutrition recommendations.
            </p>
          </div>

          <div className={styles.outcomeCopy}>
            <p className={styles.bodyText}>
              By combining practitioner expertise with intelligent technology, we help
              practitioners save valuable time, scale their practice, and deliver personalized
              nutrition care without compromising quality.
            </p>
          </div>
        </div>

        <footer className={styles.emphasisBanner}>
          <p className={styles.emphasisText}>
            Because the future of nutrition is not generic.
          </p>
          <p className={styles.emphasisText}>
            It is personalized, evidence-based, practitioner-led, and connected.
          </p>
        </footer>
      </div>
    </section>
  );
};

export default AboutUsSection;
